import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API_BASE });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("la_admin_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Extract a friendly error message from an axios error, including responses
// where responseType='blob' hid the JSON `detail` payload inside a Blob.
export const errorMessage = async (err, fallback = "Something went wrong.") => {
  const data = err?.response?.data;
  if (!data) return err?.message || fallback;
  if (typeof data === "string") return data;
  if (data instanceof Blob) {
    try { return JSON.parse(await data.text())?.detail || fallback; }
    catch { return fallback; }
  }
  return data.detail || fallback;
};

// Pull a filename from `Content-Disposition: attachment; filename="..."`.
export const filenameFromHeader = (headers, fallback) => {
  const cd = headers?.["content-disposition"] || headers?.get?.("content-disposition") || "";
  const m = cd.match(/filename\*?=(?:UTF-8'')?"?([^";]+)"?/i);
  return (m && decodeURIComponent(m[1])) || fallback;
};

// Trigger a browser download for a Blob response.
export const downloadBlob = (data, filename) => {
  const url = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement("a");
  link.href = url; link.download = filename;
  document.body.appendChild(link); link.click();
  link.remove(); window.URL.revokeObjectURL(url);
};

export default api;
